import React, { useState } from "react";
import Loader from "react-js-loader";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Box, Text } from "@chakra-ui/react";
import { upperCase } from "lodash";
import { MdAccountBalanceWallet, MdOutlineAccountBalanceWallet } from "react-icons/md";

import HelmetWrapper from "../../utils/HelmetWrapper";

export default function OrderDashboard() {
  const [loading, setLoading] = useState(false);
  const orgType = useSelector((state) => state?.login?.orgDetails?.orgType || "default");

  //
  const dashboards = [
    {
      dashboard: "COLLECTION",
      icon: MdAccountBalanceWallet,
      link: "/order/pay-in-order",
      visibility: true,
    },
    {
      dashboard: "PAYOUT",
      icon: MdOutlineAccountBalanceWallet,
      link: "/order/pay-out-order",
      visibility: orgType === "default",
    },
    {
      dashboard: "GAMING",
      icon: MdOutlineAccountBalanceWallet,
      link: "/order/gaming-order",
      visibility: orgType === "default",
    },
    { dashboard: "On-Ramp", icon: MdOutlineAccountBalanceWallet, link: "/order/onramp-order", visibility: orgType === "default" },
    { dashboard: "Off-Ramp", icon: MdOutlineAccountBalanceWallet, link: "/order/offramp-order", visibility: orgType === "default" },
    { dashboard: "PREFUND", icon: MdOutlineAccountBalanceWallet, link: "/order/prefund-order", visibility: orgType === "default" },
    // { dashboard: "Pay Orders", icon: MdOutlineAccountBalanceWallet, link: "/order/pay-order", visibility: (orgType === "default") },
  ];

  const Dashboard = (data) => {
    const details = data?.data;
    return (
      <>
        {details.visibility && (
          <div
            className="balance-card-zoom"
            style={{
              width: "250px",
              padding: "15px 20px",
              boxShadow: "0 4px 10px 2px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
              borderRadius: "4px",
              height: "130px",
            }}
          >
            <Link to={`${details.link}`}>
              <div style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}>
                <div style={{ height: "85px" }}>
                  <h3 style={{ fontSize: "20px", fontWeight: "600" }}>{upperCase(details.dashboard)}</h3>
                </div>
                <div style={{ width: "150px", height: "85px", display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                  <details.icon style={{ fontSize: "50px", marginBottom: "10px" }} />
                </div>
              </div>
            </Link>
          </div>
        )}
      </>
    );
  };

  const renderTransfiDashboards = () => {
    const transfiDashboards = Object.keys(dashboards).sort();

    return (
      <div style={{ display: "flex", justifyContent: "left", padding: "20px 10px", flexWrap: "wrap", gap: "4.45%" }}>
        {transfiDashboards.map((i, value) => {
          return (
            <div key={i} style={{ marginBottom: "40px" }}>
              <Dashboard data={dashboards[value]} />
            </div>
          );
        })}
      </div>
    );
  };

  return !loading ? (
    <>
      <HelmetWrapper title="API Dashboard - Orders" description="API Dashboard Orders Dashboard" />
      <Box w="100%" p={4}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "20px", padding: "0 10px", marginBottom: "5px" }}>
          <Text fontWeight={500}>Orders Dashboard</Text>
        </div>

        {renderTransfiDashboards()}
      </Box>
    </>
  ) : (
    <Loader type="spinner-cub" bgColor={"#FFFFFF"} title={"Loading..."} color={"cyan.400"} size={100} />
  );
}
